import { createAsyncThunk } from "@reduxjs/toolkit";

export const createApiThunk = (typePrefix, apiAction, callback) => { 
    return createAsyncThunk(typePrefix, async (args, { rejectWithValue }) => {
        try {
            const response = await apiAction(args);
            if (callback) callback(args);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
     })
}